<template>
  <v-footer   
    app
    inset
    color="transparent"
    absolute
    height="56"
    class="px-0"
  >
    <div class="boxed-container w-full">
      <div class="mx-6 d-flex justify-space-between" v-html="content"></div>
    </div>
  </v-footer>
</template>

<script>
export default {
  name: "AppFooter",

  props: ["content"],
};
</script>
